const allowedActions = [
	{
		action: 'kiosk-edit',
		role: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
	},
	{
		action: 'kiosk-verify',
		role: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
	},
	{
		action: 'kiosk-invalidate-auth',
		role: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
	},
	{
		action: 'kiosk-transactions',
		role: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
	},
	{
		action: 'kiosk-airtime',
		role: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
	},
	// {
	// 	action: 'kiosk-airtime-edit-range',
	// 	role: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
	// },
	{
		action: 'kiosk-airtime-edit-offer',
		role: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
	},
	{
		action: 'kiosk-maintenance',
		role: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_TECHNICIAN']
	},
	{
		action: 'kiosk-failed-tx',
		role: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
	}
]

export const environment = {
	production: false,
	contextPath: '',
	allowedActions: allowedActions,
	displayMomoAccount: false,
	displayAppVersions: true,
	reports: {
		dayEnd: true,
		audits: true,
		captureReportDocumentNumberPrefix: true,
		captureAccountNumber: true,		
	},
	turnstile: {
		use: false,
		siteKey: '0x4AAAAAABiUyH4lYNcgWTBT'
	}
};
